import type { ThinkAlphaTourGuideSteps } from '../types';
import { searchAlphaTgSteps } from './searchAlpha';

export const tourGuideSteps: ThinkAlphaTourGuideSteps = {
    searchalpha: searchAlphaTgSteps,
} as const;
